// Language utilities for initial setup
const CACHE_KEY = 'system_settings'

// Get settings from cache
export function getSettingsFromCache(): Record<string, any> | null {
  const settings = localStorage.getItem(CACHE_KEY)
  return settings ? JSON.parse(settings) : null
}

// Get initial language
export function getInitialLanguage(): 'zh_TW' | 'en_US' | 'pt_PT' {
  const settings = getSettingsFromCache()
  return settings?.language || 'zh_TW'
  // return 'en_US'
}

// Convert language code to i18n locale
export function getI18nLocale(lang: string): 'zh-TW' | 'zh-CN' | 'en' | 'pt' {
  const localeMap = {
    'zh_TW': 'zh-TW',
    'en_US': 'en',
    'pt_PT': 'pt'
  } as const

  return localeMap[lang as keyof typeof localeMap] || 'zh-TW'
  // return 'en'
} 